import { Component, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ToastModule } from 'primeng/toast';
import { TableModule, Table } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { TagModule } from 'primeng/tag';
import { TooltipModule } from 'primeng/tooltip';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { CalendarModule } from 'primeng/calendar';
import { MenuItem, MessageService, PrimeIcons } from 'primeng/api';
import { NGXLogger } from 'ngx-logger';
import { Utente } from '../../../models/utente.model';
import { StiliService } from '../../../services/stili.service';
import { TieredMenuModule } from 'primeng/tieredmenu';
import { Menu } from 'primeng/menu';
import { UtentiService } from '../../../services/utenti.service';
import { ModificaUtenteComponent } from './modifica/modifica-utente.component';

@Component({
  selector: 'app-utenti',
  templateUrl: './utenti.component.html',
  styleUrls: ['./utenti.component.css'],
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ToastModule,
    TableModule,
    ButtonModule,
    InputTextModule,
    MultiSelectModule,
    TagModule,
    TooltipModule,
    DialogModule,
    DropdownModule,
    CalendarModule,
    TieredMenuModule,
    ModificaUtenteComponent
  ],
  providers: [MessageService]
})
export class UtentiComponent implements OnInit {
  titoloUtenti: string = 'UTENTI';
  utenti: Utente[] = [];
  utentiCaricati: boolean = false;
  filtroTestoGlobale: string = '';
  filtriAttivi: boolean = false;
  mostraModificaUtente: boolean = false;
  utenteSelezionato: Utente | null = null;
  mostraConfermaEliminazione: boolean = false;
  utenteDaEliminare: Utente | null = null;

  @ViewChild('dt') dt!: Table;
  @ViewChild("menuAzioniTiered", { static: true }) azioniMenuTiered!: Menu;

  public menuAzioniItems!: MenuItem[];

  // Colonne da visualizzare nella tabella
  cols: any[] = [
    { field: 'nome', header: 'Nome', sortable: true, width: '20%' },
    { field: 'mail', header: 'Email', sortable: true, width: '20%' },
    { field: 'ruolo.descrizione', header: 'Ruolo', sortable: true, width: '18%' },
    { field: 'enteEsecutore.label', header: 'Ente', sortable: true, width: '35%' }
  ];

  constructor(
    private logger: NGXLogger,
    private messageService: MessageService,
    private stiliService: StiliService,
    private utentiService: UtentiService
  ) {}

  ngOnInit() {
    this.caricaUtenti();
  }

  caricaUtenti() {
    this.utentiCaricati = false;
    this.utentiService.get().subscribe({
      next: (utenti) => {
        this.utenti = utenti;
        if(this.dt) {
          if(this.filtroTestoGlobale) {
            this.dt.filterGlobal(this.filtroTestoGlobale, 'contains');
          }
        }
        this.utentiCaricati = true;
      },
      error: (error) => {
        this.logger.error('[UTENTI] Errore nel caricamento degli utenti:', error);
        this.messageService.add({
          severity: 'error',
          summary: 'Errore',
          detail: 'Si è verificato un errore nel caricamento degli utenti'
        });
        this.utentiCaricati = true;
      }
    });
  }

  onFiltroGlobaleChange(event: any) {
    this.dt.filterGlobal(event.target.value, 'contains');
  }

  pulisciFiltroGlobale() {
    this.filtroTestoGlobale = '';
    this.dt.filterGlobal('', 'contains');
  }

  openAzioni(event: any, utente: Utente): Promise<void> {
    this.loadAzioni(event, utente);
    this.azioniMenuTiered.toggle(event);
    return Promise.resolve();
  }

  loadAzioni(event: any, utente: Utente) {
    this.menuAzioniItems = [
      {
        label: "Modifica",
        icon: PrimeIcons.PENCIL,
        style: {
          'font-size': '12px'
        },
        command: () => this.modificaUtente(utente),
      },
      {
        label: "Elimina",
        icon: PrimeIcons.TRASH,
        style: {
          'font-size': '12px'
        },
        command: () => this.eliminaUtente(utente),
      }
    ];
  }

  modificaUtente(utente: Utente | null) {
    this.utenteSelezionato = utente;
    this.mostraModificaUtente = true;
  }

  onUtenteModificato(utente: Utente) {
    this.caricaUtenti();
  }

  eliminaUtente(utente: Utente) {
    if (utente.id) {
      this.utenteDaEliminare = utente;
      this.mostraConfermaEliminazione = true;
    }
  }

  confermaEliminazione() {
    if (this.utenteDaEliminare && this.utenteDaEliminare.id) {
      this.utentiService.elimina(this.utenteDaEliminare.id).subscribe({
        next: () => {
          this.messageService.add({
            severity: 'success',
            summary: 'Successo',
            detail: 'Utente eliminato con successo'
          });
          this.caricaUtenti();
        },
        error: (error) => {
          this.logger.error(`[UTENTI] Errore nell'eliminazione dell'utente ${this.utenteDaEliminare?.id}:`, error);
          this.messageService.add({
            severity: 'error',
            summary: 'Errore',
            detail: 'Si è verificato un errore nell\'eliminazione dell\'utente'
          });
        }
      });
    }
    this.mostraConfermaEliminazione = false;
    this.utenteDaEliminare = null;
  }
}
